


// const TetrisGame = () => { const [tetrisState, setTetrisState] = useState({ blocks: [], shapes: [ [ [0, 0, 0], [1, 1, 1], [0, 1, 0] ], [ [1, 0, 0], [1, 1, 1], [0, 0, 0] ], [ [0, 1, 0], [0, 1, 0], [1, 1, 0] ], [ [1, 1, 0], [1, 1, 0], [0, 0, 0] ], [ [1, 1, 0], [0, 1, 1], [0, 0, 0] ], [ [1, 0, 0], [1, 1, 0], [0, 1, 0] ], [ [1, 1, 1], [1, 0, 0], [0, 0, 0] ] ], currentShape: { currentPosition: [4, 0], currentShapeIndex: 0 } }); const move = (direction) => {
//      // Function to move the shape 
//     let newPosition; if (direction === 'down') { newPosition = [tetrisState.currentShape.currentPosition[0], tetrisState.currentShape.currentPosition[1] + 1]; } else if (direction === 'left') { newPosition = [tetrisState.currentShape.currentPosition[0] - 1, tetrisState.currentShape.currentPosition[1]]; } else if (direction === 'right') { newPosition = [tetrisState.currentShape.currentPosition[0] + 1, tetrisState.currentShape.currentPosition[1]]; } setTetrisState({ ...tetrisState, currentShape: { ...tetrisState.currentShape, currentPosition: newPosition } }); }; const drawBlock = (row, column, color) => { 
//         // Function to draw a block 
//         return ( <div style={{ width: 30, height: 30, border: '1px solid black', backgroundColor: color, position: 'absolute', top: row * 30, left: column * 30 }} ></div> ); }; const drawShapes = (shape) => {
//              // Function to draw shapes 
//              let blocks = []; for (let row = 0; row < shape.length; row++) { for (let column = 0; column < shape[row].length; column++) { if (shape[row][column]) { blocks.push(drawBlock(row + tetrisState.currentShape.currentPosition[1], column + tetrisState.currentShape.currentPosition[0], 'red')); } } } return blocks; }; const rotateShape = () => { let newShapeIndex = (tetrisState.currentShape.currentShapeIndex + 1) % tetrisState.shapes.length; setTetrisState({ ...tetrisState, currentShape: { ...tetrisState.currentShape, currentShapeIndex: newShapeIndex } }); }; let blocks = tetrisState.blocks.concat(drawShapes(tetrisState.shapes[tetrisState.currentShape.currentShapeIndex])); return ( <div> <div style={{ width: 300, height: 600, backgroundColor: 'lightgrey', position: 'relative' }} > {blocks} </div> <div> <button onClick={() => move('left')}>Left</button> <button onClick={() => move('right')}>Right</button> <button onClick={() => move('down')}>Down</button> <button onClick={rotateShape}>Rotate</button> </div> </div> ); }; export default TetrisGame;


// const TetrisGame = () => { 
//     const [tetrisState, setTetrisState] = useState({ 
//         blocks: [], 
//         shapes: [ 
//             [[0, 0, 0], [1, 1, 1], [0, 1, 0]], 
//             [[1, 0, 0], [1, 1, 1], [0, 0, 0]], 
//             [[0, 1, 0], [0, 1, 0], [1, 1, 0]], 
//             [[1, 1, 0], [1, 1, 0], [0, 0, 0]], 
//             [[1, 1, 0], [0, 1, 1], [0, 0, 0]], 
//             [[1, 0, 0], [1, 1, 0], [0, 1, 0]], 
//             [[1, 1, 1], [1, 0, 0], [0, 0, 0]] 
//         ], 
//         currentShape: { 
//             currentPosition: [4, 0], 
//             currentShapeIndex: 0 
//         }, 
//         // New States 
//         currentWaitingShapeIndex: 0, 
//         waitingShape: [] 
//     }); 

//     // Function to move the shape 
//     const move = (direction) => { 
//         let newPosition; 
//         if (direction === 'down') { 
//             newPosition = [tetrisState.currentShape.currentPosition[0], tetrisState.currentShape.currentPosition[1] + 1]; 
//         } else if (direction === 'left') { 
//             newPosition = [tetrisState.currentShape.currentPosition[0] - 1, tetrisState.currentShape.currentPosition[1]]; 
//         } else if (direction === 'right') { 
//             newPosition = [tetrisState.currentShape.currentPosition[0] + 1, tetrisState.currentShape.currentPosition[1]]; 
//         } 
//         setTetrisState({ 
//             ...tetrisState, 
//             currentShape: { 
//                 ...tetrisState.currentShape, 
//                 currentPosition: newPosition 
//             } 
//         }); 
//     }; 

//     useEffect(() => {
//         const logCoordinates = (e) => {
//           console.log(`X: ${e.screenX}, Y: ${e.screenY}`);
//         };
//         window.addEventListener('click', logCoordinates);
//         return () => {
//           window.removeEventListener('click', logCoordinates);
//         };
//       });
//     // Function to draw a block 
//     const drawBlock = (row, column, color) => { 
//         return ( 
//             <div style={{ width: 30, height: 30, border: '1px solid black', backgroundColor: color, position: 'absolute', top: row * 30, left: column * 30 }} ></div> 
//         ); 
//     }; 

//     // Function to draw shapes 
//     const drawShapes = (shape) => { 
//         let blocks = []; 
//         for (let row = 0; row < shape.length; row++) { 
//             for (let column = 0; column < shape[row].length; column++) { 
//                 if (shape[row][column]) { 
//                     blocks.push(drawBlock(row + tetrisState.currentShape.currentPosition[1], column + tetrisState.currentShape.currentPosition[0], 'red')); 
//                 } 
//             } 
//         } 
//         return blocks; 
//     }; 

//     // Function to rotate shapes 
//     const rotateShape = () => { 
//         let newShapeIndex = (tetrisState.currentShape.currentShapeIndex + 1) % tetrisState.shapes.length; 
//         setTetrisState({ 
//             ...tetrisState, 
//             currentShape: { 
//                 ...tetrisState.currentShape, 
//                 currentShapeIndex: newShapeIndex 
//             } 
//         }); 
//     }; 

//     // Function to place a new shape at the top of the board when the current shape has reached the bottom 
//     const placeNewShape = () => { 
//         // Get a random shape from the shapes array 
//         let newShapeIndex = Math.floor(Math.random() * tetrisState.shapes.length); 
//         // Set the current shape as the current waiting shape 
//         setTetrisState({ 
//             ...tetrisState, 
//             currentWaitingShapeIndex: tetrisState.currentShape.currentShapeIndex, 
//             waitingShape: tetrisState.shapes[tetrisState.currentShape.currentShapeIndex], 
//             currentShape: { 
//                 currentPosition: [4, 0], 
//                 currentShapeIndex: newShapeIndex 
//             } 
//         }); 
//     } 

//     // Function to check if the current shape has reached the bottom of the board 
//     const checkBottom = () => { 
//         // Check if the bottommost block of the current shape is at the bottom of the board 
//         let bottom = false; 
//         let currentShape = tetrisState.shapes[tetrisState.currentShape.currentShapeIndex]; 
//         for (let i = 0; i < currentShape[0].length; i++) { 
//             if (currentShape[currentShape.length - 1][i] === 1 && tetrisState.currentShape.currentPosition[1] === 17) { 
//                 bottom = true; 
//             } 
//         } 
//         // If the bottommost block of the current shape is at the bottom of the board, place a new shape at the top 
//         if (bottom) { 
//             placeNewShape(); 
//         } 
//     } 

//     let blocks = tetrisState.blocks.concat(drawShapes(tetrisState.shapes[tetrisState.currentShape.currentShapeIndex])); 

//     return ( 
//         <div> 
//             <div style={{ width: '90%', height: 600, backgroundColor: 'lightgrey', position: 'relative' }} > 
//                 {blocks} 
//             </div> 
//             <div> 
//                 <button onClick={() => move('left')}>Left</button> 
//                 <button onClick={() => move('right')}>Right</button> 
//                 <button onClick={() => move('down')}>Down</button> 
//                 <button onClick={rotateShape}>Rotate</button> 
//                 <button onClick={checkBottom}>Check Bottom</button> 
//             </div> 
//         </div> 
//     ); 
// }; 

// export default TetrisGame;



    // useEffect(() => {
    //     const logCoordinates = (e) => {
    //       console.log(`X: ${e.screenX}, Y: ${e.screenY}`);
    //     };
    //     window.addEventListener('click', logCoordinates);
    //     return () => {
    //       window.removeEventListener('click', logCoordinates);
    //     };
    //   });



    

    // useEffect(() => {
    //      // set up a variable to store the coordinates of the current tetris piece
    //      let currentPieceCoords = {};
    //       // listen for the event that is triggered when the piece is moved 
    //       window.addEventListener("tetrisPieceMoved", (ev) => { 
    //           // store the coordinates of the piece in the variable
    //            currentPieceCoords = ev.detail; });
    //            // return a function to remove the event listener when the component is unmounted 
    //            return () => window.removeEventListener("tetrisPieceMoved"); }, [])
    // Function to draw a block 






    import React, { useState, useEffect } from 'react'; 
    import { CloudSyncOutlined } from '@ant-design/icons';
    
    const TetrisGame = () => { 
      const [tetrisState, setTetrisState] = useState({ 
          blocks: [], 
          shapes: [ 
              [[0, 0,0], [1, 1, 1], [0, 1, 0]], 
              [[1, 0, 0], [1, 1, 1], [0, 0, 0]], 
              [[0, 1, 0], [0, 1, 0], [1, 1, 0]], 
              [[1, 1, 0], [1, 1, 0], [0, 0, 0]], 
              [[1, 1, 0], [0, 1, 1], [0, 0, 0]], 
              [[1, 0, 0], [1, 1, 0], [0, 1, 0]], 
              [[1, 1, 1], [1, 0, 0], [0, 0, 0]] 
          ], 
          currentShape: { 
              currentPosition: [4, 0], 
              currentShapeIndex: 0 
          }, 
          // New States 
          currentWaitingShapeIndex: 0, 
          waitingShape: [],
          // New State 
          onDeckShapeIndex: 0, 
          onDeckShape: [], 
          // New State 
          behindOnDeckShapeIndex: 0, 
          behindOnDeckShape: [], 
          // New State 
          gameStarted: false 
      }); 
  
      // Function to move the shape 
      const move = (direction) => { 
          let newPosition; 
          if (direction === 'down') { 
              newPosition = [tetrisState.currentShape.currentPosition[0], tetrisState.currentShape.currentPosition[1] + 1]; 
          } else if (direction === 'left') { 
              newPosition = [tetrisState.currentShape.currentPosition[0] - 1, tetrisState.currentShape.currentPosition[1]]; 
          } else if (direction === 'right') { 
              newPosition = [tetrisState.currentShape.currentPosition[0] + 1, tetrisState.currentShape.currentPosition[1]]; 
          } 
          setTetrisState({ 
              ...tetrisState, 
              currentShape: { 
                  ...tetrisState.currentShape, 
                  currentPosition: newPosition 
              } 
          }); 
      }; 
  


    
 useEffect = (() => {
    // set up a variable to store the coordinates of the current tetris piece
    let currentPieceCoords = {};
    // listen for the event that is triggered when the piece is moved
    window.addEventListener("tetrisPieceMoved", (ev) => {
        // store the coordinates of the piece in the variable
        currentPieceCoords = ev.detail;
        console.log(currentPieceCoords)
    });
    // return a function to remove the event listener when the component is unmounted
    return () => window.removeEventListener("tetrisPieceMoved");
}, []);


    const drawBlock = (row, column, color) => { 
        return ( 
            <div style={{ width: 30, height: 30, border: '1px solid black', backgroundColor: color, position: 'absolute', top: row * 30, left: column * 30 }} ></div> 
        ); 
    }; 

    // Function to draw shapes 
    const drawShapes = (shape) => { 
        let blocks = []; 
        for (let row = 0; row < shape.length; row++) { 
            for (let column = 0; column < shape[row].length; column++) { 
                if (shape[row][column]) { 
                    blocks.push(drawBlock(row + tetrisState.currentShape.currentPosition[1], column + tetrisState.currentShape.currentPosition[0], 'red')); 
                } 
            } 
        } 
        return blocks; 
    }; 

    // Function to rotate shapes 
    const rotateShape = () => { 
        let newShapeIndex = (tetrisState.currentShape.currentShapeIndex + 1) % tetrisState.shapes.length; 
        setTetrisState({ 
            ...tetrisState, 
            currentShape: { 
                ...tetrisState.currentShape, 
                currentShapeIndex: newShapeIndex 
            } 
        }); 
    }; 

    // Function to place a new shape at the top of the board when the current shape has reached the bottom 
    const placeNewShape = () => { 
        // Get a random shape from the shapes array 
        let newShapeIndex = Math.floor(Math.random() * tetrisState.shapes.length); 
        // Set the current shape as the current waiting shape 
        setTetrisState({ 
            ...

            tetrisState, 
            currentWaitingShapeIndex: tetrisState.currentShape.currentShapeIndex, 
            waitingShape: tetrisState.shapes[tetrisState.currentShape.currentShapeIndex], 
            currentShape: { 
                currentPosition: [4, 0], 
                currentShapeIndex: newShapeIndex 
            },
            // New State 
            onDeckShapeIndex: tetrisState.currentWaitingShapeIndex, 
            onDeckShape: tetrisState.waitingShape, 
            // New State 
            behindOnDeckShapeIndex: tetrisState.onDeckShapeIndex, 
            behindOnDeckShape: tetrisState.onDeckShape 
        }); 
    } 

    // Function to check if the current shape has reached the bottom of the board 
    const checkBottom = () => { 
        // Check if the bottommost block of the current shape is at the bottom of the board 
        let bottom = false; 
        
        document.onclick = function(e) {
            console.log("X Coordinate: " + e.clientX + ", Y Coordinate: " + e.clientY);
        }

        let currentShape = tetrisState.shapes[tetrisState.currentShape.currentShapeIndex]; 
        for (let i = 0; i < currentShape[0].length; i++) { 
            if (currentShape[currentShape.length - 1][i] === 1 && tetrisState.currentShape.currentPosition[1] === 17) { 
                bottom = true; 
            } 
        } 
        // If the bottommost block of the current shape is at the bottom of the board, place a new shape at the top 
        if (bottom) { 
            placeNewShape(); 
        } 
    } 

    // Function to start the game 
    const startGame = () => { 
        setTetrisState({ 
            ...tetrisState, 
            gameStarted: true 
        }); 
    } 

    let blocks = tetrisState.blocks.concat(drawShapes(tetrisState.shapes[tetrisState.currentShape.currentShapeIndex])); 

    return ( 
        <div> 
            <div style={{ width: '90%', height: 600, backgroundColor: 'lightgrey', position: 'relative' }} > 
                {blocks} 
            </div> 
            <div> 
                <button onClick={() => move('left')}>Left</button> 
                <button onClick={() => move('right')}>Right</button> 
                <button onClick={() => move('down')}>Down</button> 
                <button onClick={rotateShape}>Rotate</button> 
                <button onClick={checkBottom}>Check Bottom</button> 
                <button onClick={startGame}>Start Game</button> 
            </div> 
       
<a className='back-link' href="/">back home</a>

 </div> 
    ); 
}; 

export default TetrisGame;